import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

@Component({
    selector: 'data-field-edit-description',
    template: `
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'common.description' | fiAppText }}</mat-label>
                <textarea
                    matInput
                    fiAutosize="'height'"
                    [required]="dataField.IsSetRequired"
                    [(ngModel)]="dataFieldObject.Description"
                >
                </textarea>
            </mat-form-field>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'data-field-edit-description' },
    standalone: false,
})
export class DataFieldEditDescriptionComponent extends DataFieldEditBase {}
